module.exports = __webpack_public_path__ + "static/media/btn-rules.446a839d.png";